import React from 'react';

interface AIAssessmentHandlerProps {
  isLoading: boolean;
  assessmentData: any[] | null;
  children: React.ReactNode;
}

const AIAssessmentHandler: React.FC<AIAssessmentHandlerProps> = ({ isLoading, assessmentData, children }) => {
  if (isLoading) {
    return <div className="no-data-card">Loading, please wait...</div>;
  }

  if (!assessmentData || assessmentData.length === 0) {
    return (
      <div className="no-data-card">
        <div className="no-data-content">
          <div className="warning-icon">⚠️</div>
          <div className="no-data-title">No uploaded assessment found</div>
          <p className="no-data-description">
            Please upload your assessment to get an AI Diet Plan.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AIAssessmentHandler;
